export default "__VITE_ASSET__Cdd$YWoY__"